import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') ? localStorage.getItem('token') : null, // Хэрэглэгчийн token
    user: null,
    permissions: null,
    selectCompany: null,
    configData: {},
    dynamic_img_url: [],
    cdn: 'https://daagiigaadskycargo.s3.ap-southeast-1.amazonaws.com'
  },
  getters: {
    token: (state) => state.token || localStorage.getItem('token'),
    user: (state) => state.user || JSON.parse(localStorage.getItem('user')),
    permissions: (state) => state.permissions || JSON.parse(localStorage.getItem('permissions')),
    selectCompany: (state) => state.selectCompany || JSON.parse(localStorage.getItem('selectCompany')),
    configDataGetter: (state) => state.configData || JSON.parse(localStorage.getItem('configData')),
    cdnGetter: (state) => state.cdn || JSON.parse(localStorage.getItem('cdn')),
    imgUrlGetter: (state) => state.dynamic_img_url || JSON.parse(localStorage.getItem('dynamic_img_url'))
  },
  mutations: {
    setConfigData (state, data) {
      console.log(data, 'sdaa')
      state.configData = data
      localStorage.setItem('configData', state.configData) // Хадгалах
    },
    setCompanyCommit (state, company) {
      state.selectCompany = company
      localStorage.setItem('selectCompany', company) // Хадгалах
    },
    setCdnGetter (state, cdn) {
      state.cdn = cdn
      localStorage.setItem('cdn', cdn) // Хадгалах
    },
    SET_DYNAMIC_IMG_URL (state, url) {
      if (!url) return
      state.dynamic_img_url.push(url)
    },
    SET_DYNAMIC_IMG_URL_LIST (state, urls) {
      if (!urls) {
        state.dynamic_img_url = []
        return
      }
      state.dynamic_img_url = Array.isArray(urls) ? [...urls] : [urls]
    },
    setToken (state, token) {
      state.token = token
      localStorage.setItem('token', token) // Хадгалах
    },
    setUser (state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user)) // Хадгалах
    },
    setPermissions (state, permissions) {
      state.permissions = permissions
      localStorage.setItem('permissions', JSON.stringify(permissions)) // Хадгалах
    },
    removeToken (state) {
      state.token = null
      localStorage.removeItem('token') // Устгах
    },
    removeUser (state) {
      state.user = null
      localStorage.removeItem('user') // Устгах
    },
    removePermissions (state) {
      state.permissions = null
      localStorage.removeItem('permissions') // Устгах
    }
  },
  actions: {
    setConfig ({ commit }, data) {
      commit('setConfigData', data) // Token хадгалах
    },
    setCompany ({ commit }, token) {
      commit('setCompanyCommit', token) // Token хадгалах
    },
    setToken ({ commit }, token) {
      commit('setToken', token) // Token хадгалах
    },
    setUser ({ commit }, user) {
      commit('setUser', user) // Хэрэглэгчийн мэдээлэл хадгалах
    },
    setPermissions ({ commit }, permissions) {
      commit('setPermissions', permissions) // Хэрэглэгчийн мэдээлэл хадгалах
    },
    getToken ({ state }) {
      return state.token || localStorage.getItem('token') // Token авах
    },
    getUser ({ state }) {
      return state.user || JSON.parse(localStorage.getItem('user')) // Хэрэглэгчийн мэдээлэл авах
    },
    getPermissions ({ state }) {
      return state.permissions || JSON.parse(localStorage.getItem('permissions')) // Хэрэглэгчийн мэдээлэл авах
    },
    setDynamicImgUrl ({ commit }, url) {
      commit('SET_DYNAMIC_IMG_URL', url)
    },
    replaceDynamicImgUrl ({ commit }, urls) {
      commit('SET_DYNAMIC_IMG_URL_LIST', urls)
    }
  },
  modules: {
  }
})
